import { getLocationIdentities } from './GetLocationIdentities';

/**
 * Identities API Client
 * Provides low-level HTTP calls to organization-service identity endpoints
 */
export const IdentitiesApi = {
  getLocationIdentities,
};
